(function () {
  document.querySelectorAll('.fcc').forEach(function (section) {
    var track = section.querySelector('[data-fcc-track]');
    var prevBtn = section.querySelector('[data-fcc-prev]');
    var nextBtn = section.querySelector('[data-fcc-next]');
    var fill = section.querySelector('[data-fcc-progress]');

    if (!track) return;

    function step() {
      var slide = track.querySelector('.fcc__slide');
      var gap = parseInt(getComputedStyle(track).columnGap || 16, 10);
      return slide ? slide.offsetWidth + gap : 250;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;

      if (fill) {
        var thumbWidth = Math.min(100, (track.clientWidth / track.scrollWidth) * 100);
        var thumbLeft = max <= 0 ? 0 : (track.scrollLeft / max) * (100 - thumbWidth);
        fill.style.width = thumbWidth + '%';
        fill.style.left = thumbLeft + '%';
      }

      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 4;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -step() * 2, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: step() * 2, behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
